// extracted by mini-css-extract-plugin
export var content = "styles-module--content--2T7OC";
export var contentWrapper = "styles-module--content-wrapper--WvK+Z";
export var current = "styles-module--current--e4L8z";
export var designIcon = "styles-module--design-icon--52uUk";
export var devIcon = "styles-module--devIcon--dN5Ql";
export var dtIcon = "styles-module--dtIcon--dcmI3";
export var tabs = "styles-module--tabs--8CB5O";
export var top = "styles-module--top--5+Am6";
export var wrapper = "styles-module--wrapper--iQTjf";